import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CheckboxComponent } from '@modules/components/checkbox/checkbox.component';
import { SearchFieldComponent } from '@modules/components/search-field/search-field.component';
import { provideFilterItem } from '@modules/filter/utils/token';
import { FilterBean, FilterType } from '@type/filter.type';
import { FTextComponent } from '../f-text/f-text.component';

const DEFAULT_FILTER = new FilterBean(FilterType.User);

@Component({
  selector: 'app-f-user',
  imports: [SearchFieldComponent, FormsModule, CheckboxComponent],
  providers: [provideFilterItem(FUserComponent)],
  templateUrl: './f-user.component.html',
  styleUrl: './f-user.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FUserComponent extends FTextComponent {
  override translationForEmpty = 'System';

  protected override getDefaultFilter(): FilterBean {
    return { ...DEFAULT_FILTER, name: this.filter?.name || '', model: this.filter?.model || '' };
  }
}
